import React, { useEffect, useState, } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
//js
import Client from "./MainComponent/Client.js";
import Login from "./MainComponent/Login.js";

import Member from "./MainComponent/Member.js";
import PointRechargeWait from "./MainComponent/PointRechargeWait.js";
import PointRechargeApply from "./MainComponent/PointRechargeApply.js";

import Notice from "./MainComponent/Notice.js";
import QAWait from "./MainComponent/QAWait.js";
import QAApply from "./MainComponent/QAApply.js";
import FAQ from "./MainComponent/FAQ.js";
import Guide from "./MainComponent/Guide.js";
import Terms from "./MainComponent/Terms.js";


function App() {
  return (
    <div id="App_Range">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/member" element={<Member />} />
          <Route path="/recharge_point_wait" element={<PointRechargeWait />} />
          <Route path="/recharge_point_apply" element={<PointRechargeApply />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/qa_wait" element={<QAWait />} />
          <Route path="/qa_apply" element={<QAApply />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
